/**
 * Glyphs the design uses in more than one place.
 *
 * A glyph here is the path data only — no `<svg>` and no sizing — because the
 * two homes of the cart differ in both (22px at stroke 1.9 in the bottom nav,
 * 20px at stroke 1.8 in the header) and each `<svg>` wrapper owns its own.
 * Icons used once stay beside their one user.
 */
export const CartGlyph = () => (
  <>
    <circle cx="9" cy="20" r="1.4" />
    <circle cx="17" cy="20" r="1.4" />
    <path d="M3 3h2.2l2.4 12.2a1.6 1.6 0 0 0 1.6 1.3h7.9a1.6 1.6 0 0 0 1.6-1.3L20.5 7H6" />
  </>
)

/** The sliders the filter sheet opens from — three rows, each with a handle. */
export const FilterGlyph = () => (
  <>
    <path d="M4 7h16M4 12h16M4 17h16" />
    <circle cx="9" cy="7" r="2" />
    <circle cx="15" cy="12" r="2" />
    <circle cx="8" cy="17" r="2" />
  </>
)
